import React from "react";
import {useTranslation} from "react-i18next";
import {Avatar, Box, Button, Container, Fade, Paper, Typography, Zoom} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import {useNavigate} from "react-router-dom";

const Forbidden = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const role =
        localStorage.getItem("role") ||
        sessionStorage.getItem("role");


    const roleDefaultPage = {
        ADMIN: "/app/users",
        RESELLER: "/app/makmini",
        CUSTOMER: "/app",
    }[role] || "/";

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: 2,
                bgcolor: "primary.main",
                position: "relative",
                overflow: "hidden",
                "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'url("data:image/svg+xml,%3Csvg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.08"%3E%3Cpath d="M50 50c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10zM10 10c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10c0 5.523-4.477 10-10 10S0 25.523 0 20s4.477-10 10-10zm10 8c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zm40 40c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8z" /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
                    opacity: 0.3,
                },
            }}
        >
            <Container maxWidth="sm" sx={{position: "relative", zIndex: 1}}>
                <Zoom in timeout={500}>
                    <Paper
                        elevation={24}
                        sx={{
                            p: 6,
                            textAlign: "center",
                            background: "rgba(255, 255, 255, 0.98)",
                            backdropFilter: "blur(10px)",
                            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                        }}
                    >
                        <Zoom in timeout={700}>
                            <Avatar
                                sx={{
                                    width: 100,
                                    height: 100,
                                    bgcolor: "error.main",
                                    boxShadow: "0 8px 24px rgba(211, 47, 47, 0.4)",
                                    margin: "0 auto",
                                    mb: 3,
                                }}
                            >
                                <LockIcon sx={{fontSize: 55}}/>
                            </Avatar>
                        </Zoom>

                        <Fade in timeout={800}>
                            <Typography variant="h4" fontWeight={700} color="text.primary" mb={2}>
                                {t("forbidden.title")}
                            </Typography>
                        </Fade>

                        <Fade in timeout={900}>
                            <Typography variant="body1" color="text.secondary" sx={{mb: 4}}>
                                {t("forbidden.description")}
                            </Typography>
                        </Fade>

                        <Fade in timeout={1000}>
                            <Button
                                variant="contained"
                                size="large"
                                onClick={() => navigate(roleDefaultPage)}
                                color="secondary"
                                sx={{
                                    px: 5,
                                    py: 1.5,
                                    textTransform: "none",
                                    fontSize: "1rem",
                                    fontWeight: 600,
                                    boxShadow: "0 4px 15px rgba(63, 81, 181, 0.4)",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        boxShadow: "0 6px 20px rgba(63, 81, 181, 0.6)",
                                        transform: "translateY(-2px)",
                                    },
                                }}
                            >
                                {t("forbidden.goHome")}
                            </Button>
                        </Fade>
                    </Paper>
                </Zoom>
            </Container>
        </Box>
    );
};

export default Forbidden;
